
export default class Resizer {

	constructor(node, callback) {
		this.node = node;
		this.callback = callback;
    this.init();
    this.start();
	}

	init() {
		this.resize_ob = new ResizeObserver((item) => {
      if (item) {
      let rect = item[0].contentRect;
      let width = rect.width;
      let height = rect.height;
      this.callback && this.callback({width, height, item: this});
    }
    });
	}

  start() {
    this.resize_ob.observe(this.node);
  }

  stop() {
    this.resize_ob.unobserve(this.node);
  }
}
